// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OQ96","toggleWrap":"styles_toggleWrap__2RaHt","content":"styles_content__2WqDM","selectAreaCode":"styles_selectAreaCode__2xFUD"};